import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export const DirectionIcon: FunctionComponent<DirectionIconProps> = ({ width = 24, height = 24 }) => {
  const { colors } = useTheme()
  return (
    <Svg width={width} height={height} viewBox='0 0 24 24'>
      <Path
        fill={colors.iconDefault}
        d='M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.02 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z'
      />
    </Svg>
  )
}

type DirectionIconProps = {
  width?: string | number
  height?: string | number
}
